import React, { useState, useEffect } from 'react';
import DashboardLayout from './DashboardLayout';
import ReducedContent from './ReducedContent';
import { Alert } from 'react-bootstrap';
import Button from 'react-bootstrap/Button';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import { fetchMe, updateMe } from '../../api/api';
import PasswordChangeForm from '../../components/PasswordChangeForm';

const Profile = () => {
  // Personal Info State
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [showPersonalInfoSuccessAlert, setShowPersonalInfoSuccessAlert] = useState(false);
  const [showPersonalInfoErrorAlert, setShowPersonalInfoErrorAlert] = useState(false);
  const [nameError, setNameError] = useState('');
  const [personalInfoValidated, setPersonalInfoValidated] = useState(false);


  // Load user info on component mount
  useEffect(() => {
    const loadUserInfo = async () => {
      try {
        const userData = await fetchMe();
        setName(userData.name || '');
        setEmail(userData.email || '');
      } catch (error) {
        console.error('Error loading user info:', error);
        setShowPersonalInfoErrorAlert(true);
        setTimeout(() => {
          setShowPersonalInfoErrorAlert(false);
        }, 3000);
      }
    };

    loadUserInfo();
  }, []);

  const handlePersonalInfoSubmit = async (event) => {
    event.preventDefault();
    setPersonalInfoValidated(false);
    setShowPersonalInfoSuccessAlert(false);
    setShowPersonalInfoErrorAlert(false);
    setNameError('');

    let isValid = true;

    if (name === '') {
      setNameError('Campo obrigatório');
      isValid = false;
    }

    if (isValid) {
      setPersonalInfoValidated(true);

      try {
        await updateMe(name);
        setShowPersonalInfoSuccessAlert(true);
        setPersonalInfoValidated(false);
      } catch (error) {
        setShowPersonalInfoErrorAlert(true);
      }

      setTimeout(() => {
        setShowPersonalInfoErrorAlert(false);
        setShowPersonalInfoSuccessAlert(false);
      }, 3000);
    }
  };


  return (
    <div>
      <DashboardLayout title="Perfil">
        <ReducedContent>
          {/* Personal Info Section */}
          <div className="mb-5">
            <h4>Informações Pessoais</h4>
            
            {/* Success Alert */}
            {showPersonalInfoSuccessAlert && (
              <Alert variant="success" onClose={() => setShowPersonalInfoSuccessAlert(false)} dismissible>
                Informações atualizadas com sucesso!
              </Alert>
            )}

            {/* Error Alert */}
            {showPersonalInfoErrorAlert && (
              <Alert variant="danger" onClose={() => setShowPersonalInfoErrorAlert(false)} dismissible>
                Erro ao atualizar informações. Verifique os campos obrigatórios.
              </Alert>
            )}

            <Form noValidate validated={personalInfoValidated} onSubmit={handlePersonalInfoSubmit}>
              <Row className="mb-3">
                <Form.Group as={Col} md="12" controlId="name">
                  <Form.Label>Nome:</Form.Label>
                  <Form.Control
                    required
                    type="text"
                    placeholder="Nome"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    isInvalid={nameError !== ''}
                  />
                  <Form.Control.Feedback type="invalid">{nameError}</Form.Control.Feedback>
                </Form.Group>
              </Row>

              <Row className="mb-3">
                <Form.Group as={Col} md="12" controlId="email">
                  <Form.Label>Email:</Form.Label>
                  <Form.Control
                    type="email"
                    placeholder="Email"
                    value={email}
                    disabled
                    readOnly
                  />
                  <Form.Text className="text-muted">
                    O email não pode ser alterado.
                  </Form.Text>
                </Form.Group>
              </Row>

              <Button type="submit">Salvar</Button>
            </Form>
          </div>

          {/* Separator */}
          <hr className="my-5" />

          {/* Password Change Section */}
          <PasswordChangeForm showTitle={true} columnWidth="12" />
        </ReducedContent>
      </DashboardLayout>
    </div>
  );
};

export default Profile;

